<template>
<div class="page-hogehoge">

<section class="common">
    TEST
</section>

</div>
</template>


<script>
    import EndUserLayout from '@/Layouts/EndUserLayout'

    export default {
        layout: EndUserLayout,
    };
</script>